<template>
  <custom-modal v-if="vg_active" :size="'max-w-[450px]'">
    <template v-slot:maincontent>
      <div class="  text-[14px] bg-theme-modalbg rounded-lg shadow-xl">
        <div v-if="vg_noMsg==null || vg_noMsg==false" class="relative border-b border-[#414141] p-4">
          <h2 class="text-xl leading-6 tracking-[0.15px] font-bold text-white text-center " v-html="vg_msg"></h2>
          <span class="absolute right-4 top-5 pointer cursor-pointer hover:opacity-60"  @click.prevent="reject()">
           <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1.2248 13.8248L0.174805 12.7748L5.9498 6.9998L0.174805 1.2248L1.2248 0.174805L6.9998 5.9498L12.7748 0.174805L13.8248 1.2248L8.0498 6.9998L13.8248 12.7748L12.7748 13.8248L6.9998 8.0498L1.2248 13.8248Z" fill="white"/>
            </svg>

          </span>
        </div>
        
        <div class="mt-[26px] mb-[42px] tracking-wider grid-cols-4 rounded  px-4 ">
          <div class="full justify-content-center">
            <p class="text-center text-white text-base leading-5 font-normal " v-html="vg_extraMsg"></p>
          </div>
        </div>
        
        <div class="flex flex-row justify-evenly items-center px-4 pb-4 gap-4 ">
          <button v-if="vg_confirmLeft" @click.prevent="accept()" class="uppercase text-sm leading-[17.5px] tracking-[0.15px] w-full h-[44px] border-0 rounded-md p-2 block mx-auto " :class="vg_confirmClass?vg_confirmClass:'bg-theme-green hover:bg-theme-darkgreen text-white'">{{vg_confirmText}}</button>
          <button @click.prevent="reject()" class="uppercase hover:opacity-50 text-sm leading-[17.5px] tracking-[0.15px] w-full rounded-md p-2 h-[44px] block mx-auto " :class="vg_cancelClass?vg_cancelClass:'text-white border'">{{ vg_cancelText }}</button>
          <button v-if="!vg_confirmLeft" @click.prevent="accept()" class="uppercase text-sm leading-[17.5px] tracking-[0.15px] w-full h-[44px] border-0 rounded-md p-2 block mx-auto " :class="vg_confirmClass?vg_confirmClass:'bg-theme-green hover:bg-theme-darkgreen text-white'">{{vg_confirmText}}</button>
        </div>
      </div>
    </template>
  </custom-modal>
</template>
<script lang="ts">
import { defineComponent, ref } from 'vue'
import {mapGetters, mapMutations} from 'vuex'

export default defineComponent({
    setup() {
   
    },
    mounted(){
      this.vm_active(false)
    },
    computed: {
      ...mapGetters({
        vg_active: 'confirmNew/active',
        vg_msg: 'confirmNew/msg',
        vg_noMsg: 'confirmNew/noMsg',
        vg_extraMsg: 'confirmNew/extraMsg',
        vg_confirmLeft: 'confirmNew/confirmLeft',
        vg_confirmText: 'confirmNew/confirmText',
        vg_confirmClass: 'confirmNew/confirmClass',
        vg_cancelText: 'confirmNew/cancelText',
        vg_cancelClass: 'confirmNew/cancelClass',
      })
    },
    methods: {
      reject(){
        this.vm_reject()
      },
      accept(){
        this.vm_accept()
      },
      ...mapMutations({
        vm_active: 'confirmNew/active',
        vm_accept: 'confirmNew/accept',
        vm_reject: 'confirmNew/reject'
      })
    }
})
</script>
